// export const clearAllCookies = () => {
export const clearAllCookies = async () => {
  if (typeof window !== 'undefined') {
    try {
      // fetch('/api/token/logout', {
      await fetch('/api/token/logout', {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
      }).catch(() => null);
    } catch (e) {}
  }
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
};

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return false;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return (payload.exp || 0) * 1000 > Date.now();
  } catch (e) {
    return false;
  }
};

let isLoggingOut = false;
// export const handleLogout = () => {
export const handleLogout = async () => {
  if (typeof window !== 'undefined') {
    if (isLoggingOut) return;
    isLoggingOut = true;
    try {
      const userLanguage = localStorage.getItem('userLanguage');
      localStorage.clear();
      if (userLanguage) {
        localStorage.setItem('userLanguage', userLanguage);
      }
      // clearAllCookies();
      await clearAllCookies();
      window.dispatchEvent(new Event('auth:unauthorized'));
    } finally {
      setTimeout(() => {
        isLoggingOut = false;
      }, 2000);
    }
  }
};
